// 말소 홈·말소 탭 목록 행 — FinalWeb2 `.row`: 아이콘 타일 · `차량번호 · 차종` / `날짜 · 유형`(완료+말소증이면 '말소증 도착') · 상태 pill.
// 날짜 = homeLogic.rowDate(완료 건은 완료일, 그 외 신청일 — 기간 필터와 같은 기준).
// 타일: 확인 필요 = 앰버 · 완료 = 초록(서류 체크) · 그 외 회색(차량). 선택 행(2-pane)은 accent 바.
// 대행사 거래처(시안 List `.cl2`): 부제 앞 칩 = 거래처 라벨, 없으면 '○○가 신청'(하위 회사 화면 · 시안 SubList, D4 accent).
// 칩 뒤 글자 = ['○○가 신청'(칩으로 안 쓴 경우), 날짜, 유형] — brokerLogic.js. 칩이 있으면 부제를 줄바꿈 허용(시안 `.sub` flex-wrap —
// 한 줄 고정이면 날짜·유형이 잘린다). 칩 없는 행(비대행사·구 서버)은 현행 한 줄 그대로.
// props: { row, needsAction, certArrived, selected, onClick }
import React from 'react';
import { T, R, FONT } from '../../theme';
import { useT, useLocale } from '../../../i18n/I18nProvider';
import LtrText from '../../simple/parts/LtrText';
import { rowDate } from '../homeLogic';
import { unitLabel, requestedBy } from '../brokerLogic';

var CAR = 'M5 17h14M6 17l1.5-6h9L18 17M8 17v2M16 17v2';
var DOC_OK = 'M7 3h7l5 5v13H7zM14 3v5h5M10 14l2 2 4-4';

// status → [키, 글자색, 배경, 테두리] — 리뷰 P4 매핑. 모르는 상태는 회색 + 원문.
var PILL = {
  '대기': ['cancelAgencyStatusWaiting', T.muted, T.track, T.bd],
  '접수': ['cancelAgencyStatusReceived', T.accentPress, T.accentTint, T.accentBd],
  '진행중': ['cancelHistoryFilterActive', T.accentPress, T.accentTint, T.accentBd],
  '수거완료': ['cancelAgencyStatusPickedUp', T.accentPress, T.accentTint, T.accentBd],
  '보류': ['reqAdminStatusHold', T.warn, T.warnTint, T.warnBd],
  '완료': ['cancelAgencyStatusDone', T.ok, T.okTint, T.okBd]
};
var TYPE_KEY = { '수출말소': 'reqAdminCancelTypeExport', '폐차말소': 'reqAdminCancelTypeScrap' };

var pillBox = { display: 'inline-flex', alignItems: 'center', gap: 5, height: 22, padding: '0 9px', borderRadius: R.pill,
  fontSize: FONT.badge + 0.5, fontWeight: 700, whiteSpace: 'nowrap', flex: 'none', boxSizing: 'border-box' };
var dot = { width: 5, height: 5, borderRadius: '50%', background: 'currentColor', flex: 'none' };

export function MalsoStatusPill(props) {
  var t = useT();
  var m = PILL[props.status];
  var style = Object.assign({}, pillBox, m
    ? { color: m[1], background: m[2], border: '1px solid ' + m[3] }
    : { color: T.muted, background: T.track, border: '1px solid ' + T.bd });
  return (<span className="ss-pill" data-status={props.status || ''} style={style}>
    <i style={dot} />{m ? t(m[0]) : (props.status || '-')}
  </span>);
}

// 선택/기본 변형은 키 집합이 같아야 한다(v2 theme.js 규칙 — 단축만 교체).
var rowBase = { display: 'flex', alignItems: 'center', gap: 12, minHeight: 56, padding: '8px 14px', width: '100%',
  minWidth: 0, border: 0, borderBottom: '1px solid ' + T.bdSoft, borderInlineStart: '3px solid transparent',
  background: T.card, cursor: 'pointer', fontFamily: 'inherit', textAlign: 'start', boxSizing: 'border-box' };
var rowSel = Object.assign({}, rowBase, { background: T.accentTint, borderInlineStart: '3px solid ' + T.accent });
var tile = { width: 34, height: 34, borderRadius: R.lg, display: 'grid', placeItems: 'center', flex: 'none' };
var txWrap = { flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column', gap: 1 };
var titleStyle = { fontSize: 13.5, fontWeight: 700, color: T.ink, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' };
var subStyle = { fontSize: 11.5, color: T.muted, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' };
var subWrap = { fontSize: 11.5, color: T.muted, display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '1px 6px', minWidth: 0 };
var unitChip = { padding: '0 6px', borderRadius: R.sm, background: T.accentTint, color: T.accentPress, fontWeight: 700 };

function MalsoRow(props) {
  var t = useT();
  var locale = useLocale().locale;
  var r = props.row || {};
  var unit = unitLabel(r, t);
  var by = requestedBy(r, t, locale);
  var chip = unit || by;
  var lead = unit && by ? by + ' · ' : '';
  var done = r.status === '완료';
  var tone = props.needsAction ? { background: T.warnTint, color: T.warn }
    : done ? { background: T.okTint, color: T.ok } : { background: T.track, color: T.muted };
  var kind = props.certArrived ? t('malsoModeRowCertArrived') : (TYPE_KEY[r.cancelType] ? t(TYPE_KEY[r.cancelType]) : (r.cancelType || ''));
  return (<button type="button" className="ss-rw" data-request-id={r.id} aria-current={props.selected ? 'true' : undefined}
    style={props.selected ? rowSel : rowBase} onClick={props.onClick}>
    <span style={Object.assign({}, tile, tone)}>
      <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
        strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false">
        <path d={done ? DOC_OK : CAR} />
      </svg>
    </span>
    <span style={txWrap}>
      <span style={titleStyle}><LtrText>{r.carNo || '-'}</LtrText>{r.carType ? ' · ' + r.carType : ''}</span>
      {chip ? (<span data-part="row-sub" style={subWrap}><span data-part="unit-chip" style={unitChip}>{chip}</span>
        <span>{lead}<LtrText>{rowDate(r)}</LtrText>{kind ? ' · ' + kind : ''}</span></span>)
        : <span data-part="row-sub" style={subStyle}><LtrText>{rowDate(r)}</LtrText>{kind ? ' · ' + kind : ''}</span>}
    </span>
    <MalsoStatusPill status={r.status} />
  </button>);
}

export default MalsoRow;
